import { useMemo } from 'react';

const useCurrencyFormatter = (locale = 'es-CO', currency = 'COP') => {
  const formatter = useMemo(
    () =>
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
      }),
    [locale, currency]
  );

  return (amount: number) => {
    return formatter.format(amount);
  };
};

export default useCurrencyFormatter;
